import { ButtonLink } from "ui/components/Button/ButtonLink";
import { transformRoute } from "helpers";
import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation";
import { VehicleContractHeaderProps } from "./types";

const VehicleContractHeader = ({
  vehicleId,
  onAdd,
}: VehicleContractHeaderProps) => {
  return (
    <div className="flex items-center gap-2">
      <ButtonLink
        size="small"
        variant="warning"
        children="Pregled"
        to={transformRoute(
          FleetVehicleRoutes.FleetVehicleContractSearchPageRouter,
          {
            id: vehicleId,
          }
        )}
        startIcon="/media/icons/search.svg"
      />
    </div>
  );
};

export default VehicleContractHeader;